export const desktopHeader = {
  name: 'desktop-header',
  path: 'M0,0 H1 V0.875 C1,0.875,0.739,0.994,0.501,1 C0.262,1,0,0.874,0,0.874 V0',
};
export const mobileHeader = {
  name: 'mobile-header',
  path: 'M0,0 H1 V0.907 C1,0.907,0.749,0.996,0.51,1 C0.272,1,0,0.915,0,0.915 V0',
};
